import { type SidebarItemDTO, SystemWebDavName } from "data/types";
import loc from "i18next";

export const siteDisplayName = (site: SidebarItemDTO): string => {
    const nameIndex = Object.values(SystemWebDavName).indexOf(site.caption);

    if (nameIndex !== -1) {
        return loc.t(`common:siteItemType.${site.siteType}`);
    }

    return site.caption;
};
